import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'PriceSavings',
  props: {
    prefix: null,
    suffix: null,
    savingsText: null
  },
  setup(__props: any) {



return { __sfc: true, }
}

})